<template>
  <div>
    <!-- 搜索表单 -->
    <el-form ref="form" :model="query" inline size="mini" label-width="100px">
      <el-form-item label="商家信息">
        <el-input v-model="query.merchant" clearable placeholder="请输入商家信息"></el-input>
      </el-form-item>
      <el-form-item label="房间信息">
        <el-input v-model="query.room" clearable placeholder="请输入房间信息"></el-input>
      </el-form-item>
      <el-form-item label="代理信息">
        <el-input v-model="query.agent" clearable placeholder="请输入代理信息"></el-input>
      </el-form-item>
      <el-form-item label="员工信息">
        <el-input v-model="query.staff" clearable placeholder="请输入员工信息"></el-input>
      </el-form-item>
      <el-form-item label="商家模式">
        <el-select v-model="query.businessType" placeholder="请选择商家模式" clearable>
          <el-option label="无人" value="1"></el-option>
          <el-option label="滴滴" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备编码">
        <el-input v-model="query.eqpUuid" clearable placeholder="请输入设备SN码"></el-input>
      </el-form-item>
      <el-form-item label="房间状态">
        <el-select v-model="query.isUse" clearable placeholder="请选择房间状态">
          <el-option label="使用中" value="1"></el-option>
          <el-option label="空闲中" value="0"></el-option>
          <el-option label="打扫中" value="2"></el-option>
          <el-option label="报障中" value="3"></el-option>
        </el-select>
      </el-form-item>

      <el-button type="primary" size="mini" @click="seach">搜索</el-button>
    </el-form>
    <!-- 卡片视图 -->
    <el-card class="box-card">
      <!-- 展开行数据展示 -->
      <el-table :data="deviceList"  style="width: 100%" height="650px" border="" stripe :cell-style="cellStyle">
        <!-- 展开行区域 -->
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-form label-width="110px" label-position="left" inline class="expand">
              <el-form-item label="房间标识:">
                <span>{{ scope.row.uuid }}</span>
              </el-form-item>
              <el-form-item label="房间简介:">
                <span>{{ scope.row.description }}</span>
              </el-form-item>
              <el-form-item label="房间描述:">
                <span>{{ scope.row.remark }}</span>
              </el-form-item>
              <el-form-item label="背景图片:">
                <el-image style="width: 100%; height: 75px" :src="scope.row.backgroundImage.split(';')[0]" :preview-src-list="scope.row.backgroundImage.split(';')"></el-image>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <!-- 表格数据展示区域 -->
        <el-table-column prop="name" label="房间名称"></el-table-column>
        <el-table-column prop="" label="收费标准" width="120">
           <template slot-scope="scope">
             <span>{{scope.row.unitPrice}}元/{{scope.row.priceType==88?'1.0小时':'0.5小时'}}</span>
           </template>
        </el-table-column>
        <!-- <el-table-column prop="" label="计费时长" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.calcHoursDay }}小时</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="merchantName" label="所属商家"></el-table-column>
        <el-table-column prop="agentName" label="所属代理" width="100"></el-table-column>
        <el-table-column prop="staffName" label="所属员工" width="100"></el-table-column>
        <el-table-column label="运营" width="70">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.businessType === 1" type="warning">无人</el-tag>
            <el-tag v-if="scope.row.businessType === 2" type="danger">滴滴</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="模式" width="70">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 1" type="warning">预付</el-tag>
            <el-tag v-if="scope.row.type === 2" type="danger">预约</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="房间状态" width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isUse === 1">使用中</el-tag>
            <el-tag v-else-if="scope.row.isUse === 2" type="warning">打扫中</el-tag>
            <el-tag v-else type="success">空闲中</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="equipmentUuid" label="设备编码" width="160">
          <template slot-scope="scope">
            <div v-if="scope.row.equipmentUuid" class="uuidBox" @click="createdQrcode(scope.row.equipmentUuid)">
              <i class="el-icon-camera" style="padding-right: 5px;"></i>
              <el-popover placement="right" width="164" trigger="click">
                <img :src="qrCodeUrl">
                <span slot="reference">{{scope.row.equipmentUuid}}</span>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="设备状态" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.startup">在线</el-tag>
            <el-tag v-else type="info">离线</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <el-button type="danger" :disabled="scope.row.isDeleted==1 || scope.row.isUse == 1" icon="el-icon-delete" size="mini" @click="del(scope.row.uuid)">删除</el-button>
            <el-button type="danger" :disabled="scope.row.isDeleted==1 || scope.row.isUse == 1 || !scope.row.equipmentUuid" size="small" @click="tongdian(scope.row.equipmentUuid, 1)">上电</el-button>
            <el-button type="danger" :disabled="scope.row.isDeleted==1 || scope.row.isUse == 1 || !scope.row.equipmentUuid" size="small" @click="tongdian(scope.row.equipmentUuid, 2)">断电</el-button>
            <!-- <el-button type="danger" size="small" @click="unbinding(scope.row.uuid)">强制解绑</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="CurrentPageChange"
        :current-page="query.curPage"
        :page-sizes="[5, 10, 15]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
    <!-- 绑定记录数据展示框 -->
    <el-dialog title="设备绑定记录" :visible.sync="recordDialogVisible" width="80%">
      <el-table :data="bindRecord" style="width: 100%" border="" stripe>
        <el-table-column prop="createTime" label="变更时间"></el-table-column>
        <el-table-column label="变更类型">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.bindingType === 1">代理变更</el-tag>
            <el-tag type="warning" v-else>商家变更</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="beforeBindingUuid" label="变更前代理ID"></el-table-column>
        <el-table-column prop="beforeBindingName" label="变更前代理名称"></el-table-column>
        <el-table-column prop="beforeBindingCellphone" label="变更前代理号码"></el-table-column>
        <el-table-column prop="afterBindingUuid" label="变更后代理ID"></el-table-column>
        <el-table-column prop="afterBindingName" label="变更后代理名称"></el-table-column>
        <el-table-column prop="afterBindingCellphone" label="变更后代理号码"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { list, delete1, operate } from '@/API/room'
import Qrcode from 'qrcode'
import { baseQR } from '@/base.js'
export default {
  name: 'rooms',
  data() {
    return {
      // 设备列表请求参数
      query: {
        curPage: 1,
        pageSize: 10,
        eqpUuid: '',
        binding: '',
        snStart: '',
        snEnd: '',
        ctEnd: '',
        ctStart: ''
      },
      // 时间段
      period1: [],
      // 设备列表数据
      deviceList: [],
      // 数据总条数
      total: 0,
      // 添加
      addDialogVisible: false,
      // 添加设备表单参数
      addForm: {
        model: 1,
        uuid: ''
      },
      // 添加单个设备表单验证规则
      addRules: {
        uuid: [{ required: true, message: '请输入设备SN码', trigger: 'blur' }]
      },
      // 充电柜详情数据
      cabinetInfo: {},
      // 充电柜详情数据对话框是否显示
      cabineDialogTableVisible: false,
      // 充电线详情数据
      lineInfo: [],
      // 充电线密码对话框是否显示
      lineDialogTableVisible: false,
      // 绑定记录数据列表
      bindRecord: [],
      // 绑定数据展示框是否显示
      recordDialogVisible: false,
      // 二维码url地址
      qrCodeUrl: '',
      onlineUpgradeDialogTableVisible: false
    }
  },
  created() {
    this.getRoomList()
  },
  methods: {
    async getRoomList() {
      const { data: res } = await list(this.query)
      if (res.code !== 200) return this.$message.error(res.message)
      this.deviceList = res.data.entities
      this.total = res.data.totalSize
    },
    // 搜索按钮点击触发
    seach() {
      this.query.curPage = 1
      if (this.period1 != null && this.period1 !== []) {
        this.query.ctStart = this.period1[0]
        this.query.ctEnd = this.period1[1]
      } else {
        this.query.ctStart = ''
        this.query.ctEnd = ''
      }
      this.getRoomList()
    },
    // 重置按钮点击触发
    custody() {
      this.query = {
        curPage: 1,
        pageSize: 10
      }
      this.getRoomList()
    },
    // 监听pageSize的变化值
    pageSizeChange(newSize) {
      this.query.pageSize = newSize
      this.getRoomList()
    },
    // 监听currentPage的变化
    CurrentPageChange(newPage) {
      this.query.curPage = newPage
      this.getRoomList()
    },
    del(roomUuid) {
      this.$confirm('此操作将删除设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const { data: res } = await delete1({ roomUuid })
          if (res.code !== 200) return this.$message.error(res.message)
          this.getRoomList()
          this.$message.success(res.message)
        })
    },
    // 设备回拨
    retrieve(eqpUuid) {
      this.$confirm('此操作将回收设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          // eslint-disable-next-line no-undef
          const { data: res } = await opreate({ eqpUuid, mode })
          if (res.code !== 200) return this.$message.error(res.message)
          this.getRoomList()
          this.$message.success(res.message)
        })
    },

    tongdian(eqpUuid, mode) {
      let a = '上电'
      if (mode !== 1) {
        a = '断电'
      }
      this.$confirm('此操作将' + a + '设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await operate({ eqpUuid, mode })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
      })
    },

    // 点击设备SN码生成二维码
    createdQrcode(data) {
      let shareUrl = baseQR + 'Agounet/anmonp?MID=' + data
      Qrcode.toDataURL(shareUrl).then(Url => {
        this.qrCodeUrl = Url
        this.qrcodeDialogTableVisible = true
      })
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (row.isDeleted === 1) {
        return 'background: #f5f7fa;'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.seachBtn {
  display: inline-block;
  margin-left: 45px;
}
.el-input,
.el-date-picker,
.el-select {
  width: 180px !important;
}
.el-card__body {
  padding: 0;
  .el-form-item {
    margin: 0;
    margin: 0;
    width: 33%;
  }
  .uuidBox {
    position: relative;
    cursor: pointer;
  }
  .el-pagination {
    padding-top: 20px;
  }
}
.el-table-column {
  box-sizing: content-box;
}
.qrcodeBox {
  position: fixed;
  bottom: 100px;
  left: 18px;
  z-index: 99;
}
.visibleBox {
  .el-form {
    .el-form-item {
      margin: 0;
      margin: 0;
      width: 25%;
    }
    .el-button {
      margin-top: 4px;
    }

  }
}
.onlineUpgrade {
    .el-select {
      width: 300px !important;
    }
}
.el-tag {
  margin-left: 3px !important;
}
</style>
